import { flagsmithConfig } from './flagsmith'
import flagsmith from 'flagsmith'
import type { IFlagsmith } from 'flagsmith/types'
import { datadogRum } from '@datadog/browser-rum'
import { initDatadogWithFlagsmith } from '@/helpers/integrations/datadog'

// Initialize Flagsmith client
let flagsmithClient: IFlagsmith | null = null

/**
 * Initialize the Flagsmith client if not already initialized
 */
export function initializeFlagsmithClient(): IFlagsmith {
  if (!flagsmithClient) {
    flagsmithClient = flagsmith
    flagsmithClient.init({
      environmentID: flagsmithConfig.environmentID,
      enableLogs: false,
      datadogRum: initDatadogWithFlagsmith(datadogRum)
    })
  }
  return flagsmithClient
}

/**
 * Get a flag value by name
 * @param flagName The name of the flag to retrieve
 * @returns The flag value or null if not found
 */
export function getFlag(
  flagName: string
): { enabled: boolean; value?: string | number | boolean | null } | null {
  try {
    const client = initializeFlagsmithClient()
    if (client.hasFeature(flagName)) {
      return {
        enabled: client.hasFeature(flagName),
        value: client.getValue(flagName)
      }
    }
    return null
  } catch (e) {
    console.error(`Error getting flag ${flagName}:`, e)
    return null
  }
}
